import {
  RHFCircleToggleGroupLabelled,
  RHFTextField,
  RHFCircleToggleGroupChildren,
  RHFRadioGroup,
  RHFCheckboxGroup,
  Section,
} from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import React from "react";
import AuraBloodPressure from "../components/organisms/AuraBloodPressure";
import AuraMultipleChoice from "../components/organisms/AuraMultipleChoice";
import AuraNumericTextQuestion from "../components/organisms/AuraNumericTextQuestion";
import AuraOccupationAutoComplete from "../components/organisms/AuraOccupationAutoComplete";
import AuraQuestionDate from "../components/organisms/AuraQuestionDate";
import AuraSingleChoiceQuestion from "../components/organisms/AuraSingleChoiceQuestion";
import AuraUnitizedDateNumericChoice from "../components/organisms/AuraUnitizedDateNumericChoice";
import AuraUnitizedQuestion from "../components/organisms/AuraUnitizedQuestion";
import {
  getMappedQuestionDateResponse,
  getMappedQuestionRadioResponse,
  getMappedQuestionResponse,
  getMappedQuestionSearchResponse,
  getMappedQuestionTextResponse,
  getMappedQuestionUnitizedResponse,
} from "../utilities/auraHealthUtils";

function AuraComponentFactory({
  componentType,
  nextAuraQuestion,
  control,
  defaultValue,
  setUnitizedDropdownOption,
  setAnsRemapDropDwnNumericCount,
}) {
  switch (componentType) {
    // case "RadioResp":
    case "SINGLE_CHOICE":
      // circle toggle component //RadioResp
      const mappedComponentRes = getMappedQuestionResponse(nextAuraQuestion);
      return <AuraSingleChoiceQuestion mappedContent={mappedComponentRes} />;
    case "NUMERIC":
      //Text component //TextInput
      const mappedNumericRes = getMappedQuestionTextResponse(nextAuraQuestion);
      return (
        <AuraNumericTextQuestion
          mappedContent={mappedNumericRes}
          isNumberType={true}
        />
      );
    case "UNITIZED":
      //TextInput or Dropdown-TextInput
      const mappedUnitizedRes =
        getMappedQuestionUnitizedResponse(nextAuraQuestion);
      return (
        <AuraUnitizedQuestion
          mappedContent={mappedUnitizedRes}
          isNumberType={true}
          setUnitizedDropdownOption={setUnitizedDropdownOption}
          control={control}
          defaultValue={defaultValue}
          setAnsRemapDropDwnNumericCount={setAnsRemapDropDwnNumericCount}
        />
      );
    case "MULTIPLE_CHOICE":
      // checkbox component //CheckBoxResp
      const mappedCheckboxCompRes =
        getMappedQuestionRadioResponse(nextAuraQuestion);
      return (
        <AuraMultipleChoice
          mappedContent={mappedCheckboxCompRes}
          defaultValue={defaultValue}
        />
      );
    case "UNITIZED_CHOICE":
    case "DATE_CHOICE":
    case "NUMERIC_CHOICE":
      // radio component // SingleSelectBoxResp
      const mappedRadioCompRes =
        getMappedQuestionRadioResponse(nextAuraQuestion);
      return (
        <AuraUnitizedDateNumericChoice mappedContent={mappedRadioCompRes} />
      );
    case "DATE":
      const mappedDateCompRes = getMappedQuestionDateResponse(nextAuraQuestion);
      return <AuraQuestionDate mappedContent={mappedDateCompRes} />;
    case "SEARCH":
      const mappedSearchCompRes =
        getMappedQuestionSearchResponse(nextAuraQuestion);
      return (
        <AuraOccupationAutoComplete
          control={control}
          mappedContent={mappedSearchCompRes}
        />
      );
    case "TEXT":
      //Text component //TextInput
      const mappedFreeTextResp =
        getMappedQuestionTextResponse(nextAuraQuestion);
      return (
        <AuraNumericTextQuestion
          mappedContent={mappedFreeTextResp}
          isNumberType={false}
        />
      );
    case "BLOOD_PRESSURE":
      const mappedBPCompRes = getMappedQuestionSearchResponse(nextAuraQuestion);
      return <AuraBloodPressure mappedContent={mappedBPCompRes} />;
    default:
      return (
        <Typography variant="p3">
          {" "}
          Problem occurred while rendering the component - {componentType}
        </Typography>
      );
  }
}

export default AuraComponentFactory;
